module.exports = __webpack_public_path__ + "static/Transportation-69d194b65a3f80a0478e5e68503820ee.jpg";